<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <div class="flex-row-generic ">
      <!-- External Id Control -->
      <div class="flex-item-two-columns">
        <div class="form-group">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input
            id="{{ baseId }}-id"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
            formControlName="externalID"
          />
          <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-id" class="incorrect-input" translate>
            {{ externalIdControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>
      </div>
      <!-- External Id Control -->

      <!-- Occupation Code Control -->
      <div class="flex-item-two-columns">
        <div class="form-group">
          <label for="{{ baseId }}-occupationCode" translate>Occupation Code</label>
          <input
            id="{{ baseId }}-occupationCode"
            class="form-control"
            [ngClass]="{ error: showErrors(occupationCodeControl, isSubmitted), 'required': isRequired(occupationCodeControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.OccupationCode.MaxLength"
            formControlName="occupationCode"
          />
          <div *ngIf="showErrors(occupationCodeControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
            {{ occupationCodeControl.errors | fcListValidation : 'Occupation Code' }}
          </div>
        </div>
      </div>
      <!-- Occupation Code Control -->
    </div>

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <div class="dropdown">
        <input
          id="{{ baseId }}-name"
          class="form-control"
          [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Name.MaxLength"
          formControlName="name"
        />
      </div>
      <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name" translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl)}"
        id="{{ baseId }}-notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        formControlName="notes"
        rows="3"
      >
      </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined </mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>
